import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { BroadcastService } from "../../../../../shared/services/broadcast.service";
import { FormService } from "../../../../../shared/services/form.service";
import { takeUntil } from "rxjs/operators";
import { Subject, forkJoin } from "rxjs";
import { RxFormGroup } from "@rxweb/reactive-form-validators";
import { MediasService } from "../../../../../services/medias.service";
import { EventType } from "../../../../../shared/interfaces/event.model";
import { CategoryService } from "../../../../../services/category.service";
import { CustomersService } from "../../../../../services/customers.service";
import { SwalService } from "../../../../../shared/services/swal.service";
import { MediaClientsService } from "../../../../../services/media-clients.service";
import { MediaClientModel } from "../models/media-client.model";
import { CompanyClientService } from "../../../../../services/company-clients.service";

@Component({
	selector: "app-edit-create-media-clients",
	templateUrl: "./edit-create-media-clients.component.html",
	styleUrls: ["./edit-create-media-clients.component.scss"],
})
export class EditCreateMediaClientsComponent implements OnInit {
	@Input() data: any = {};
	formGroup: RxFormGroup;
	isEdit = false;

	fields: any = {
		name: {
			type: "input",
			options: {
				path: "name",
				class: "col-sm-12",
				label: {
					text: "Titulo",
					class: "col-sm-12",
				},
			},
		},
		legal_name: {
			type: "input",
			options: {
				path: "legal_name",
				class: "col-sm-12",
				label: {
					text: "Razon Social",
					class: "col-sm-12",
				},
			},
		},
		address: {
			type: "input",
			options: {
				path: "address",
				label: {
					text: "Dirección",
				},
			},
		},
		client_id: {
			type: "select",
			options: {
				path: "client_id",
				label: {
					text: "Partner",
				},
				dropdown: {
					text: "Seleccione...",
					options: [],
				},
			},
		},
		company_client_id: {
			type: "select",
			options: {
				path: "company_client_id",
				label: {
					text: "Compañia",
				},
				dropdown: {
					text: "Seleccione...",
					options: [],
				},
			},
		},
		email: {
			type: "email",
			options: {
				path: "email",
				label: {
					text: "Correo Electrónico",
				},
			},
		},
		tax_id: {
			type: "input",
			options: {
				path: "tax_id",
				label: {
					text: "RFC",
				},
			},
		},
		contact_name: {
			type: "input",
			options: {
				path: "contact_name",
				label: {
					text: "Nombre del Representante",
				},
			},
		},
		phone_number: {
			type: "input",
			options: {
				path: "phone_number",
				label: {
					text: "Número de Telefono",
				},
			},
		},
		notes: {
			type: "textarea",
			options: {
				path: "notes",
				class: "col-sm-12",
				label: {
					text: "Nota",
				},
			},
		},
		active: {
			type: "switch",
			options: {
				path: "active",
				label: {
					text: "¿Activo?",
				},
				switchers: {
					trueCaption: "Si",
					falseCaption: "No",
				},
			},
		},
	};

	constructor(
		private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private mediaService: MediasService,
		private categoryService: CategoryService,
		private customersService: CustomersService,
		private companiesclientService: CompanyClientService,
		private sweetService: SwalService,
		private mediaclientService: MediaClientsService,
	) {
		this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((form) => {
				this.formGroup = form;
				this.cdr.detectChanges();
			});
	}

	isAdmin: boolean = false;

	private atComponentDestroy = new Subject();

	async ngOnInit(): Promise<void> {
		this.formService.transformIntoFormGroup(
			MediaClientModel,
			this.data ?? {},
		);

		this.isAdmin = this.data?.IsAdmin || false;

		let clientsResponse = await this.customersService.getActives();
		let companiesclientResponse =
			await this.companiesclientService.getActives();
		let clients = clientsResponse ?? [];
		let companies = companiesclientResponse ?? [];
		clients = clients.map((data) => ({ id: data.id, name: data.name }));
		companies = companies.map((data) => ({ id: data.id, name: data.name }));

		this.fields.client_id.options.dropdown.options = [...clients];
		this.fields.company_client_id.options.dropdown.options = [...companies];

		if (this.data?.id) {
			this.isEdit = true;
		}
	}

  submit(): void {
    console.log(this.formGroup.value)
    this.formGroup.value.active = this.formGroup.value.active === true ? 1 : 0;
		this.mediaclientService.createOrUpdate(this.formGroup, this.data?.id)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(data => {
				this.broadcast.reloadDataTable();
				this.broadcast.reloadInit();
				this.modalRef.hide();
				this.sweetService.success();
			}, error => {
				console.error("Error al enviar los datos:", error);
			});
	}
}
